"use client";
import Link from "next/link";
import React, { useState } from "react";
import Icon from "../primitives/icon";

interface Sportsbook {
  id: Number;
  attributes: {
    title: String;
    slug: String;
    description: String;
    color: String;
    logo: Object;
    light_logo: Object;
    legal_states: Object;
  };
}

interface BettingGuidePage {
  label: String;
  slug: String;
}

const BETTING_GUIDE_PAGES: BettingGuidePage[] = [
  {
    label: "Overview",
    slug: "",
  },
  {
    label: "Favorites & Underdogs",
    slug: "favorites-underdogs",
  },
  {
    label: "Odds",
    slug: "odds",
  },
  {
    label: "Spread Bets",
    slug: "spread-bets",
  },
  {
    label: "Moneyline Bets",
    slug: "moneyline-bets",
  },
  {
    label: "Over/Under (Totals) Bets",
    slug: "over-under-totals-bets",
  },
  {
    label: "Parlay Bets",
    slug: "parlay-bets",
  },
  {
    label: "Same Game Parlays",
    slug: "same-game-parlays",
  },
];

export default function BettingGuideDropdown({}) {
  let [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <a
        className="block text-secondary-100 uppercase cursor-pointer"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        Betting Guide{" "}
        <Icon className="ml-1 align-middle" name="caret-down" size="xs"></Icon>
      </a>
      {isOpen && (
        <div className="pl-6">
          {BETTING_GUIDE_PAGES.map((page: BettingGuidePage) => (
            <Link
              className="block text-secondary-100 uppercase"
              href={`/betting-guide/sports-betting-101/${page.slug}`}
            >
              {page.label}
            </Link>
          ))}
        </div>
      )}
    </>
  );
}
